import React from 'react';
import { Route } from '../Routing/types';
import { ArticlePage } from '@front-activerse/modules';
import { Error404 } from '@front-activerse/modules';

const dummy_t = (translationKey: string) => translationKey;

const descendantRoutes: Route[] = [
  {
    path: '/:article',
    element: <ArticlePage />,
    private: false,
    title: dummy_t('feed.navbarTitle'),
    mobileAppTabIdentifier: 'profile',
  },
  {
    path: '/:article/*', // Not Found route for nested routes
    element: <Error404 />,
    private: false,
    title: dummy_t('feed.navbarTitle'),
    mobileAppTabIdentifier: 'profile',
  },
];

export default descendantRoutes;
